import type { IssueTrigger } from './types';

export interface AutoIssueState {
  trigger: IssueTrigger;
  prefix: string;
  expiresInDays: string;
  limitPerUser: string;
  maxPerReferrer: string;
  viTitle: string;
  viBody: string;
  viCta: string;
  enTitle: string;
  enBody: string;
  enCta: string;
}

export const emptyAutoIssue = (): AutoIssueState => ({
  trigger: 'NONE',
  prefix: '',
  expiresInDays: '14',
  limitPerUser: '1',
  maxPerReferrer: '',
  viTitle: '',
  viBody: '',
  viCta: '',
  enTitle: '',
  enBody: '',
  enCta: '',
});

export const templateToJson = (state: AutoIssueState): string | null => {
  const entry = (title: string, body: string, ctaLabel: string) => {
    const value = {
      ...(title.trim() ? { title: title.trim() } : {}),
      ...(body.trim() ? { body: body.trim() } : {}),
      ...(ctaLabel.trim() ? { ctaLabel: ctaLabel.trim() } : {}),
    };
    return Object.keys(value).length > 0 ? value : undefined;
  };
  const vi = entry(state.viTitle, state.viBody, state.viCta);
  const en = entry(state.enTitle, state.enBody, state.enCta);
  return vi || en ? JSON.stringify({ ...(vi ? { vi } : {}), ...(en ? { en } : {}) }) : null;
};

export const parseTemplate = (json: string | null): Partial<AutoIssueState> => {
  if (!json) return {};
  try {
    const t = JSON.parse(json) as Record<
      string,
      { title?: string; body?: string; ctaLabel?: string }
    >;
    return {
      viTitle: t.vi?.title ?? '',
      viBody: t.vi?.body ?? '',
      viCta: t.vi?.ctaLabel ?? '',
      enTitle: t.en?.title ?? '',
      enBody: t.en?.body ?? '',
      enCta: t.en?.ctaLabel ?? '',
    };
  } catch {
    return {};
  }
};
